import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/zu.webp',
  './images/zu1.webp',
  './images/zu2.webp',
  './images/zu3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Zhangjiajie, located in Hunan Province, is famed for its otherworldly sandstone pillars, dense forests, and thrilling glass bridges. It's one of China’s top nature destinations and inspired the floating mountains in the movie *Avatar*.

Top places to visit:

• Zhangjiajie National Forest Park – Home to the iconic Avatar Hallelujah Mountain and a UNESCO World Heritage Site.
• Tianmen Mountain – Ride the world’s longest cableway to the top and walk the breathtaking glass skywalk.
• Zhangjiajie Glass Bridge – The world's highest and longest glass-bottom bridge spanning the Zhangjiajie Grand Canyon.
• Yuanjiajie Scenic Area – Known for its misty peaks and the “First Bridge under Heaven.”
• Golden Whip Stream – A scenic hiking trail with crystal-clear waters and monkey sightings.
• Baofeng Lake – Take a serene boat ride surrounded by lush cliffs and waterfalls.
• Tianzi Mountain – Offers panoramic views of spire-like peaks rising above the clouds.
• Yellow Dragon Cave – A massive karst cave system with underground rivers and colorful stalactites.
• Grand Canyon of Zhangjiajie – Features dramatic cliffs and the famous glass bridge.
• Ten-Mile Gallery – A sightseeing train route through picturesque valleys and cliff walls.

Zhangjiajie is ideal for adventurous travelers and nature lovers, with dramatic landscapes and unforgettable views.`,

    zh: `张家界位于湖南省，是中国最著名的自然景观胜地之一，以奇特的砂岩峰林、原始森林和刺激的玻璃桥而闻名。电影《阿凡达》中漂浮山的灵感就来源于这里。

推荐景点：

• 张家界国家森林公园 – 联合国教科文组织世界遗产地，拥有“哈利路亚山”等奇峰怪石。
• 天门山 – 乘世界最长的索道登顶，体验惊险刺激的玻璃栈道。
• 张家界大峡谷玻璃桥 – 世界最高最长的玻璃桥，横跨大峡谷，美景震撼。
• 袁家界 – 云雾缭绕、峰林密布，有“天下第一桥”等标志性景观。
• 金鞭溪 – 水清石秀，适合徒步，是猴群栖息之地。
• 宝峰湖 – 湖水清澈，环绕山崖和瀑布，可乘船悠游。
• 天子山 – 可俯瞰云海峰林，摄影爱好者的天堂。
• 黄龙洞 – 洞中有河、瀑布和丰富的钟乳石景观，规模宏大。
• 张家界大峡谷 – 陡峭险峻，拥有全球知名的玻璃桥。
• 十里画廊 – 可乘观光小火车，穿梭于如诗如画的山谷之中。

张家界以其壮观的自然风光吸引着无数探险者与摄影爱好者，是一处令人流连忘返的旅游胜地。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/zu.webp" className="travel-image2" />
          <img src="./images/zu1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Zhangjiajie</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Zhangjiajie</h2>
          <p className="carousel-subheading">
            Witness towering peaks, thrilling glass bridges, and mystical landscapes.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
